module.exports = __webpack_public_path__ + "static/media/icons-sport-outdoor.5816ff64.svg";


//////////////////
// WEBPACK FOOTER
// ./src/newDropshipperApp/images/icons-sport-outdoor.svg
// module id = 787
// module chunks = 0